module.exports = __webpack_public_path__ + "img/podcast-icon.8f398861.svg";